import React, { useEffect, useState } from 'react';
import { dialogService } from './dialogService';
import CustomDialog from '../../components/dialogs/CustomDialog';
import { DialogInfo } from '@/core/types';

const DialogManager: React.FC = () => {
  const [dialog, setDialog] = useState<DialogInfo | null>(null);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const unSubShow = dialogService.onShow((dialog: DialogInfo) => {
      setDialog(dialog);
      setIsOpen(true);
    });
    const unSubClose = dialogService.onClose(() => {
      setDialog(null);
      setIsOpen(false);
    });
    return () => {
      unSubShow();
      unSubClose();
    };
  }, []);

  if (!dialog) return null;

  const handleClose = (result: unknown) => {
    dialog.resolve(result);
    setDialog(null);
  };

  return React.createElement(CustomDialog, {
    isOpen,
    onClose: handleClose,
    config: dialog.config,
  });
};

export default DialogManager;
